import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" onClick={scrollToTop} className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">蘑菇视频</span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed">
              蘑菇视频聚合西瓜视频免费、蜜桃视频等平台，提供高清电影电视剧免费在线观看，无广告流畅播放，VIP电影免费看。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" onClick={scrollToTop} className="text-foreground-300 hover:text-background-50 text-sm transition-colors">首页</Link></li>
              <li><Link to="/category/dianying" onClick={scrollToTop} className="text-foreground-300 hover:text-background-50 text-sm transition-colors">电影</Link></li>
              <li><Link to="/category/dianshiju" onClick={scrollToTop} className="text-foreground-300 hover:text-background-50 text-sm transition-colors">电视剧</Link></li>
              <li><Link to="/category/zongyi" onClick={scrollToTop} className="text-foreground-300 hover:text-background-50 text-sm transition-colors">综艺</Link></li>
              <li><Link to="/category/dongman" onClick={scrollToTop} className="text-foreground-300 hover:text-background-50 text-sm transition-colors">动漫</Link></li>
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">更多内容</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/jilupian" onClick={scrollToTop} className="text-foreground-300 hover:text-background-50 text-sm transition-colors">纪录片</Link></li>
              <li><Link to="/category/shaoer" onClick={scrollToTop} className="text-foreground-300 hover:text-background-50 text-sm transition-colors">少儿</Link></li>
              <li><Link to="/about" onClick={scrollToTop} className="text-foreground-300 hover:text-background-50 text-sm transition-colors">关于我们</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-foreground-300 text-sm">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@mogushipin.com</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-300 text-sm">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2 text-foreground-300 text-sm">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>北京市朝阳区望京科技园</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; 2024-2026 蘑菇视频 mogushipin.com 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="https://weixin.qq.com" target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-background-50 text-sm"></i>
            </a>
            <a href="https://weibo.com" target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-background-50 text-sm"></i>
            </a>
            <a href="https://www.douyin.com" target="_blank" rel="nofollow noopener" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="抖音">
              <i className="ri-tiktok-line text-background-50 text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}